export default __webpack_public_path__ + "static/media/icon_nav_back.fb1d80e2.svg";